exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/group-management/group-edit/group-edit.component.css
// module id = ../../../../../src/app/group-management/group-edit/group-edit.component.css
// module chunks = main